import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import { ArrearsComiteeReportResponse } from './types';

export const getCollectionsDocumentIndicators = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/indicators/documents`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionsManagementsIndicators = async (
  dispatch: Dispatch,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/indicators/management`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionsRecoveryIndicators = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/indicators/recovery`,
    dispatch,
  });
  if (response) return response.data;
};

export const completeCollectionManagement = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/${id}/complete`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const completeMultipleCollectionManagement = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/complete/batch`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const deleteMultipleCollectionManagement = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/collection/management/delete/batch`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const rescheduleMultipleCollectionManagement = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/reschedule/batch`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const unDoCompleteCollectionManagement = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/${id}/uncomplete`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCollectionManagementById = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/management/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsForCollection = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAvailableDocumentsForCollection = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/available?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentDetailedForCollection = async (
  dispatch: Dispatch,
  id: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getExecutivesForDocumentCollection = async (
  dispatch: Dispatch,
  query: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/available/collectors?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsChartsData = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/documents/charts`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessUsersPortfolio = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/businesses/portfolio`,
    dispatch,
  });
  if (response) return response.data;
};

export const rescheduleCollectionManagement = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/${id}/reschedule`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const createMultipleCollectionManagement = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/management/multiple/create`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getByStakeholder = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/byStakeholder`,
    dispatch,
  });
  if (response) return response.data;
};

export const getManagementsGroupedBy = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/groupedByBusiness?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getManagementsByBusiness = async (
  dispatch: Dispatch,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/managements/byBusiness/${businessId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentsDataForCollection = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/collection/documents/data`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getArrearsComiteeReport = async (
  dispatch: Dispatch,
): Promise<ArrearsComiteeReportResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/collection/arrearsComitee`,
    dispatch,
  });
  if (response) return response.data;
};
